<template>
  <div class="Wdgt-Auth-Module">
    <TelegramAuth class="Wdgt-Auth-Module__social-btn" />
    <p class="Wdgt-Auth-Module__separator">или Войти с помощью</p>
    <GoogleAuth v-if="GOOGLE_AUTH_ENABLED" class="Wdgt-Auth-Module__social-btn" />
    <ButtonSocial class="Wdgt-Auth-Module__social-btn" :text="'Электронная почта'" @click="toGoToLoginForm"/>
    <ButtonSocial class="Wdgt-Auth-Module__social-btn" :text="'Войти по ссылке'" @click="toGoToMagicLink"/>
    <p class="Wdgt-Auth-Module__help-txt Wdgt-Auth-Module__help-txt--wide">
      Если раньше вы входили через Google — <button class="Wdgt-Auth-Module__help-lnk" @click="toGoToForgotPass">сбросьте пароль</button> или воспользуйтесь <button class="Wdgt-Auth-Module__help-lnk" @click="toGoToMagicLink">входом по ссылке</button>.
    </p>
    <p class="Wdgt-Auth-Module__ftr-txt">
      Нет аккаунта? <button class="Wdgt-Auth-Module__lnk" @click="toOpenSignupSection">Зарегистрироваться</button>
    </p>
  </div>
</template>

<script setup>
  import { useStore } from 'vuex';
  import AUTH_SECTIONS_NAME from '@shared/constants/dropdowns/authSectionsName.js';
  //------------------------------
  import GoogleAuth from '@widgets/Authorization/components/GoogleAuth/GoogleAuth.vue';
  import { GOOGLE_AUTH_ENABLED } from '@shared/constants/featureFlags';
  import TelegramAuth from "@widgets/Authorization/components/TelegramAuth/TelegramAuth2.vue";
  import ButtonSocial from '@shared/UI/Buttons/ButtonSocial/ButtonSocial';
  //----------------------------
  const store = useStore();
  //------------------------------
  //Открыть стартовую секцию регистрации
  const toOpenSignupSection = () => {
    store.commit('AuthorizationSystem/toActiveSection', AUTH_SECTIONS_NAME.START_SIGNUP);
  }
  //Открыть форму логина
  const toGoToLoginForm = () => {
    store.commit('AuthorizationSystem/toActiveSection', AUTH_SECTIONS_NAME.LOGIN_FORM);
  }
  //Открыть форму входа по ссылке
  const toGoToMagicLink = () => {
    store.commit('AuthorizationSystem/toActiveSection', AUTH_SECTIONS_NAME.MAGIC_LINK_REQUEST);
  }
  //Открыть форму сброса пароля
  const toGoToForgotPass = () => {
    store.commit('AuthorizationSystem/toActiveSection', AUTH_SECTIONS_NAME.FORGOT_PASS);
  }
</script>

<style lang="scss">
  @import '../../styles/Wdgt-Auth-Module.scss';
</style>
